import * as SwitchPrimitives from '@radix-ui/react-switch';
import * as React from 'react';

import { cn } from '@/lib/utils';

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      'tw:peer tw:inline-flex tw:h-4 tw:w-8 tw:shrink-0 tw:cursor-pointer tw:items-center tw:rounded-full '
      + 'tw:border tw:border-slate-400 tw:shadow-sm tw:transition-colors '
      + 'tw:disabled:cursor-not-allowed tw:disabled:opacity-30 tw:data-[state=checked]:bg-primary tw:data-[state=unchecked]:bg-white '
      + 'tw:transition-shadow tw:duration-150 tw:ease-in-out '
      + 'tw:focus:outline-hidden tw:focus:ring-4 tw:focus:ring-blue-500/40 ',
      className
    )}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb
      className={cn(
        'tw:pointer-events-none tw:block tw:ml-[2px] tw:h-[9px] tw:w-[9px] tw:rounded-full tw:bg-slate-300 tw:shadow-lg '
        + 'tw:ring-0 tw:transition-transform tw:data-[state=checked]:translate-x-[13px] tw:data-[state=checked]:bg-white '
        + 'tw:data-[state=unchecked]:translate-x-0'
      )}
    />
  </SwitchPrimitives.Root>
));
Switch.displayName = SwitchPrimitives.Root.displayName;

export { Switch };
